module.exports = __webpack_public_path__ + "static/media/combat(8).1aa04898.PNG";